<div class="header-modal">
    <i class="fa fa-times icon-close-modal" (click)="emitClose()" ></i>
    <div class="content-left">
        <img src="https://storage.googleapis.com/f2rt-assets/Iconos/Logo_F2RT-negro.svg" class="logo-f2rt">
        <div class="content-title">{{title}}</div>
    </div>
    <div class="content-right">
    </div>
</div>